import { Controller } from "@hotwired/stimulus"

// Disclosure-button state for the planning grid's client panes: keeps
// aria-expanded truthful, and keeps the button's bottom corners following the
// wrapper's rounded border while collapsed.
//
// The shared `collapse` controller toggles a `hidden` class on its content
// targets but does not touch ARIA, and it is used across the app, so this sits
// alongside it rather than changing it: the button declares both controllers
// and both actions. Without this the client group headers on the Chains
// Missions planning grid would either be mouse-only or advertise a stale
// expanded state to screen readers.
export default class extends Controller {
  toggle() {
    const expanded = this.element.getAttribute("aria-expanded") === "true"
    const nowExpanded = !expanded
    this.element.setAttribute("aria-expanded", String(nowExpanded))

    // Bottom corners: a child clips to the PADDING box, whose radius is the
    // wrapper's minus its 1px border, so a square-cornered grey header notches
    // the curve. rounded-t-lg fixed the top, but with panes now collapsed by
    // default the button is the ONLY visible child, so its square bottom
    // corners sit against the wrapper's rounded bottom and notch it too.
    // It can't be unconditional: expanded, a curved bottom edge sitting on a
    // square content block reads wrong. State is toggled client-side, so a
    // server-rendered conditional can't follow it -- hence here, alongside the
    // aria flip, rather than a second controller for one class.
    // Literal class string, no interpolation and no arbitrary value: this
    // app's Tailwind build does not generate those.
    this.element.classList.toggle("rounded-b-lg", !nowExpanded)
  }
}
